import React from "react";
var __jsx = React.createElement;
import OilOptionCard from "./OilOptionCard";
var OilProductOptions = function OilProductOptions(_ref) {
  var section = _ref.section;
  var content = section.content;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex gap-3 overflow-x-auto pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden md:grid md:grid-cols-1 md:gap-3 md:overflow-x-visible"
  }, content.options.map(function (option) {
    var _option$id;
    return /*#__PURE__*/React.createElement(OilOptionCard, {
      key: (_option$id = option.id) !== null && _option$id !== void 0 ? _option$id : option.value,
      option: option,
      productId: content.id,
      cartTitle: section.title,
      cartSubtitle: content.description,
      productLogo: content.logo,
      referralLocation: "oil_details"
    });
  }));
};
export default OilProductOptions;